export default {"src":"/accounts/_next/static/media/progress-indicator.83579fef.gif","height":58,"width":51,"blurWidth":0,"blurHeight":0};